import { useSyncExternalStore } from 'react'

const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)'

function subscribe(onChange: () => void) {
  const mediaQuery = window.matchMedia?.(DARK_SCHEME_QUERY)
  mediaQuery?.addEventListener('change', onChange)
  return () => mediaQuery?.removeEventListener('change', onChange)
}

function getSnapshot(): 'light' | 'dark' {
  return window.matchMedia?.(DARK_SCHEME_QUERY).matches ? 'dark' : 'light'
}

/**
 * The theme this device's System setting resolves to (the computer's light or
 * dark mode), kept current as the computer switches, as ThemeController
 * resolves it.
 */
export function useSystemTheme(): 'light' | 'dark' {
  return useSyncExternalStore(subscribe, getSnapshot, () => 'light')
}
